import { createSlice } from '@reduxjs/toolkit';

export const priceQuoteSlice = createSlice({
  name: 'priceQuote',
  initialState: {
    value: {
      goldPlan: '',
      silverPlan: ''
    },
  },
  reducers: {
    setValue: (state, action) => {
      const newValue = action.payload;
      state.value = newValue;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setValue } = priceQuoteSlice.actions;

export default priceQuoteSlice.reducer;
